<template>
  <div
    class="app-wrap"
    :class="routerType ? '' : 'Count'"
  >
    <router-view />
    <!-- <keep-alive>
      <router-view />
    </keep-alive> -->
    <loginType @openRegister="openRegister" ref="child"></loginType>

    <!-- 注册 -->
    <el-dialog width="476px" :visible.sync="dialogFormVisible">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人用户" name="first"></el-tab-pane>
        <el-tab-pane label="企业用户" name="second"></el-tab-pane>
        <el-tab-pane label="海外用户" name="third"></el-tab-pane>
      </el-tabs>
      <div class="tabsCount">
        <el-form ref="form" :rules="rules" :model="userForm">
          <el-form-item prop="name">
            <el-input
              clearable
              v-model="userForm.name"
              :placeholder="activeName == 'first' ? '姓名' : '请输入公司名称'"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phoneNo">
            <el-input
              clearable
              v-model="userForm.phoneNo"
              :placeholder="
                activeName == 'third' ? '请输入联系电话' : '请输入手机号码'
              "
            ></el-input>
          </el-form-item>
          <el-form-item v-if="activeName == 'third'" prop="email">
            <el-input
              clearable
              v-model="userForm.email"
              placeholder="请输入工作邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              clearable
              type="password"
              v-model="userForm.password"
              placeholder="密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="comPassword">
            <el-input
              clearable
              type="password"
              v-model="userForm.comPassword"
              placeholder="确认密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <div style="width: 100%" class="center_Style">
              <div>
                <el-input
                  clearable
                  style="width: 276px"
                  v-model="userForm.verificationCode"
                  :placeholder="
                    activeName == 'third' ? '邮箱验证码' : '短信验证码'
                  "
                ></el-input>
              </div>
              <div style="margin-left: 10px">
                <el-button
                  @click="sendCode()"
                  style="width: 150px"
                  type="primary"
                  plain
                  >{{
                    countDown <= 0 ? "获取验证码" : countDown + "s"
                  }}</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div style="padding: 15px 0;text-align: right;">
          <el-checkbox style="" v-model="checked">我已阅读
          </el-checkbox>
          <span style="" @click.stop="toPolicy()" data-v-9aa3ee46="">《亦邦物流用户服务条款》</span>
        </div>
      </div>
      <div style="padding-bottom: 50px" slot="footer" class="dialog-footer">
        <el-button
          style="width: 100%"
          type="primary"
          @click="validateForm('form')"
          >立即注册</el-button
        >
      </div>
    </el-dialog>
    <!-- 协议条款弹窗 -->
    <el-dialog
      title="服务条款"
      center
      :visible.sync="registerPolicyDialog"
      width="50%"
    >
      <!-- <div v-html="registerContext" style="text-align: center;"></div> -->
      <div style="">
        <p style="font-size: 26px">服务条款</p>
        <p>协议构成及须知</p>
        <p>
          1.
          本协议是亦邦物流网络平台注册用户（包括使用亦邦物流网络平台的个人和所代表的企业）与亦邦物流网络平台之间的法律契约，注册亦邦物流网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即亦邦物流用户）且自发出协议之时即受协议条款的约束。
        </p>
        <p>
          2.
          本协议受中华人民共和国法律管辖，签约地为深圳。下文中的亦邦物流是本协议的契约方之一。下文中的“用户”指亦邦物流网络平台注册用户，是本协议的契约方之另一方。
        </p>
        <p>
          3.
          用户欲访问和使用亦邦物流网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制亦邦物流网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消亦邦物流网络平台提供的服务。对亦邦物流网络平台的使用行为将被视为对本协议条款的完全接受，包括接受亦邦物流网络平台对条款所做的任何修改。
        </p>
        <p style="font-size: 22px">用户使用规则</p>
        <p>
          1.
          亦邦物流网络平台服务仅限于为用户提供正常和合法业务工具，用户如果使用亦邦物流网络平台产品从事以下行为，即导致根本性违约，亦邦物流网络平台有权随时停止服务、解除本协议，并追讨因此带来的损失：
          1）有明确证据表明用户使用亦邦物流网络平台用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。
          2）对亦邦物流网络平台产品进行了任何形式的对其他第三方的再授权使用，销售或转让。
          3）提供的公司信息或个人资料不真实，或有可能对亦邦物流网络平台其他用户构成误导甚至欺诈。
          4）滥用亦邦物流网络平台产品的通信功能发送垃圾邮件和短信。
          5）对亦邦物流网络平台的连续服务和商誉构成损害的其他行为，包括对亦邦物流网络平台服务器的攻击。
          6）其他亦邦物流网络平台认为是不符合整体服务需求的特殊情形。
        </p>
        <p>
          2.
          亦邦物流网络平台使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在亦邦物流网络平台所登记的域名时，亦邦物流网络平台有权随时删除该用户的所有数据。
        </p>
        <p>
          3.
          用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。
        </p>
        <p style="font-size: 22px">知识产权</p>
        <p>
          1.
          用户完全拥有在使用亦邦物流网络平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从亦邦物流网络平台中复制、导出和删除。
        </p>
        <p>
          2.
          亦邦（深圳）国际物流有限公司完全拥有亦邦物流网络平台的全部知识产权，用户签署本协议后并未拥有亦邦物流网络平台的所有权。亦邦（深圳）国际物流有限公司的公司名称、标志、LOGO、产品名字，以及亦邦物流网络平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都归属亦邦（深圳）国际物流有限公司，未经授权不能使用。
        </p>
        <p>
          3.
          用户不得将涉及亦邦物流网络平台拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制亦邦物流网络平台产品，亦不可基于商业目的模仿亦邦物流网络平台的产品和服务。用户不可复制和模仿亦邦物流网络平台的设计理念、界面、功能和文字及图形说明。未经亦邦（深圳）国际物流有限公司许可，用户不得基于此协议所约定的服务对亦邦物流网络平台进行修改或制造、衍生其它产品。
        </p>

        <p style="font-size: 22px">数据安全及保密</p>

        <p>
          1.
          亦邦物流网络平台每天都对用户储存在亦邦物流服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。
        </p>
        <p>
          2.
          用户有义务维护自己在亦邦物流网络平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供亦邦物流网络平台的全部或部分服务，也不得容许他人通过自己的账户使用亦邦物流网络平台。
        </p>
        <p>
          3.
          亦邦物流的客服人员不接受用户的口头请求对其密码进行重置。对所有用户输入的信息和上传的文件，
          亦邦物流员工不能对其进行其他任何侵犯隐私的操作。
        </p>
        <p>
          4.
          用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏亦邦物流网络平台的安全或授权措施，不可翻阅或存取非自己所有的数据。
        </p>
        <p>
          5.
          除应政府或司法机关调查或法律要求外，亦邦（深圳）国际物流有限公司直接口头或书面向第三方提供涉及用户在使用亦邦物流网络平台过程中保存在亦邦物流服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求亦邦物流按协议相应条款赔偿。
        </p>
        <p>
          6.
          本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于亦邦物流不正当的原因已经为公众所知的；(2)由亦邦物流以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息;
          (4)由于法律、法院或其他国家有权机关的要求而披露的信息。
        </p>
        <p>
          7.
          亦邦物流保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。
        </p>
        <p>
          8.
          亦邦（深圳）国际物流有限公司保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但亦邦物流不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。
        </p>
        <p style="font-size: 22px">不可抗力及免责条款</p>
        <p>
          1.
          因一切不由亦邦物流可控因素引起的服务中断和长时间终止不属于亦邦物流违约，不承担赔偿责任。不可控因素包括但不限于：
          1）用户方客户终端硬件及网络，互联网络，机房供电系统故障；
          2）不可抗力： 地震、台风、洪水等自然灾害；
          战争、罢工、停电、政府行为等； 政府电力部门或电信部门的行为；
          电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；
          INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；
          外部人为破坏因素引起的，超过安全设备的承载能力。
          3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。
        </p>
        <p>
          遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。
        </p>

        <p>
          2.
          亦邦物流不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。
        </p>
        <p>
          3.
          亦邦物流对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。
        </p>
        <p>
          4.
          在任何情况下，亦邦物流对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。
        </p>
        <p>
          5.
          亦邦物流网络平台、论坛、博客中的所有言论并不代表亦邦物流的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，亦邦物流将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但亦邦物流不承担任何责任。
        </p>
        <p style="font-size: 22px">条款修订</p>
        <p>
          1.
          亦邦物流有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在亦邦物流网站。
        </p>
        <p>2. 修订的条款始终公开在亦邦物流网络平台条款页面</p>
        <p style="font-size: 22px">争议解决</p>
        <p>
          如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。
        </p>
      </div>
    </el-dialog>
    <!--<serviceText></serviceText>-->
  </div>
</template>

<script>
import qs from "qs";
import loginType from "../../common/loginType";
import serviceText from '../../common/serviceText'
import Utils from '../../common/util.js';
export default {
  name: "index",
  components: {
    loginType,
    serviceText
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.userForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[34578]\d{9}$$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };

    return {
      // register data

      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        comPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],

        verificationCode: [
          {
            type: "number",
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      registerPolicyDialog: false,

      // register data end

      checked: true,
      activeName: "first",
      countDown: 0,
      timer: "",
      userForm: {
        cusType: "",
        email: "",
        name: "",
        password: "",
        comPassword: "",
        phoneNo: "",
        verificationCode: "",
      },
      dialogFormVisible: false,
      routerType: false,
      prefix: "",
      goodsTypeId: "", //当前选择的货物类型
      guojiaData: null, //选择的国家
      Citydata: null, //选择的城市
      cangkuitem: null, //仓库
      houseHis: [],
      Authorization: localStorage.getItem("Authorization_lineSupplier")
        ? JSON.parse(localStorage.getItem("Authorization_lineSupplier"))
        : null,
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(val);
        if (this.$route.path != "/index/placeOrder/placeIndex") {
          this.routerType = true;
        } else {
          this.routerType = false;
        }
      },
    },
  },
  //方法集合
  methods: {
    shouType(num) {
      console.log('123')
        Utils.$emit('demo',num);
    },
    /* // jack start */
    openRegister(){
     // 显示注册弹窗
     this.dialogFormVisible = true

    },
    // 协议条款弹窗
    toPolicy() {
      this.registerPolicyDialog = true;
    },
    // 发送验证码或邮箱验证
    sendCode() {
      // 先判断那种注册
      if (this.activeName == "first" || this.activeName == "second") {
        let flag = /^1[34578]\d{9}$/.test(this.userForm.phoneNo);
        if (!flag) {
          this.$message.info("请输入正确手机号");
          return;
        }
        // 判断正则结束
      } else {
        /* 海外注册 */
        let flag = /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/.test(
          this.userForm.email
        );
        if (!flag) {
          this.$message.info("请输入正确的邮箱号");
          return;
        }
        // 判断正则结束
      }

      if (this.countDown > 0) {
        return;
      }

      // 判断是用邮箱还是手机
      let No =
        this.activeName == "first"
          ? this.userForm.phoneNo
          : this.activeName == "second"
          ? this.userForm.phoneNo
          : this.userForm.email;
      // 判断如果是海外就 邮箱url
      let url =
        this.activeName == "third"
          ? "sendRegisterCodeByEmail/"
          : "requestRegisterSmsCode/";

      this.axios
        .get("corporation/" + url + No)
        .then((res) => {
          if (res.data.code != 200) {
            this.$message.info(res.data.message);

            return;
          }

          // this.$message.info(res.data.message)

          clearInterval(this.timer);
          this.$message.info("已发送");

          this.countDown = 30;

          this.timer = setInterval(() => {
            this.countDown--;
          }, 1000);
        })
        .catch((res) => {
          this.$message.info(res.data.message);
        });
    },
    // 注册
    register() {
      // 判断那种注册
      this.userForm.cusType =
        this.activeName == "first"
          ? "G"
          : this.activeName == "second"
          ? "Q"
          : "H";

      this.axios
        .post(`corporation/registerCustomer`, this.userForm)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message.success("注册成功！请登录");
            this.resetForm("form");
            if (this.timer) {
              clearInterval();
            }

            this.countDown = 0;
            this.dialogFormVisible = false;
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 验证注册信息
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message.info("请您先同意服务协议");
            return;
          }
          this.register();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* // jack end */

    logonShow() {
      this.dialogFormVisible = true;
    },
    handleClick(tab, event) {
      this.tabName = tab.name;
      for (let key in this.userForm) {
        this.userForm[key] = "";
      }
      console.log(tab.name);
    },
    openLogin() {
      console.log("123");
      this.$refs.child.showDialog(1);
    },
    pathIndex() {
      this.$router.push("/index/placeOrder/placeIndex");

    },
    PathTo(command) {
      console.log(command);
      if (command == "a") {
        //个人中心 - 默认首页
        this.$router.push({
          name: "platformSharedWarehouse",
        });
      } else if (command == "b") {
        this.$router.push("/index/placeOrder/placeIndex");
      } else if (command == "c"){
        this.$confirm("确定退出并返回吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let beforeEmail = localStorage.getItem('before_email');
            localStorage.clear();
            sessionStorage.removeItem("Authorization_lineSupplier");
            sessionStorage.removeItem("authList");
            if(beforeEmail){
              localStorage.setItem('before_email',beforeEmail);
            }
            this.$router.push("/index/placeOrder/placeIndex");
            this.$store.state.Authorization = null;

          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }else if (command == "d"){
        this.$router.push("/index/placeOrder/placeIndex");
      }
    },
  },
  created() {
    if (this.$route.path != "/index/placeOrder/placeIndex") {
      this.routerType = true;
    } else {
      this.routerType = false;
    }
  },
  mounted() {
    // console.log(this);
  },
};
</script>
<style scoped lang="scss">
   /*快速登陆*/
  .loginBtn {
    cursor: pointer;
    border: 1px solid #fff;
    width: 100px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    margin-right: 10px;
    text-align: center;
    float: left;
  }

  /* 注册 */
  .zhuce {
    background: #ff7200;
    cursor: pointer;
    border: 1px solid #ff7200;
    width: 100px;
    height: 35px;
    line-height: 35px;
    color: #ffffff;
    margin-right: 10px;
    text-align: center;
    float: left;
  }
   .center_Style {
     display: flex;
     display: -webkit-flex;
     align-items: center;
   }
  /* 容器*/
  .app-wrap {
    min-width: 1366px;
    width: 100%;
    height: 100%;
    display: flex;
    /*flex-direction: column;*/
    background-color: #FBFBFB;
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue